var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 54.525,
    viewBox: "0 0 69 54.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download-cloud-svgrepo-com",
    d: "M36.5,31.056V57.111m0,0-8.375-8.685M36.5,57.111l8.375-8.685M16.4,52.768a13.683,13.683,0,0,1-3.752-26.754.566.566,0,0,0,.4-.542A20.289,20.289,0,0,1,33.15,5a20.289,20.289,0,0,1,20.1,20.472.336.336,0,0,0,.407.33,13.2,13.2,0,0,1,2.943-.33,13.65,13.65,0,0,1,0,27.3",
    transform: "translate(-2 -4)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.59b290a12f330bbe27d713bd9437b7de.svg";
export { ForwardRef as ReactComponent };